<template>
    <section class="container" :class="css.container">
        <!-- * 描述信息（不管是否存在译文, 仅存在原文展示） -->
        <div class="module-descript text-hint" v-if="!origin.descript.origin">{{ $t("Placeholder.NotModuleDescript") }}</div>
        <template v-else>
            <div class="module1-descript">{{ origin.descript.default }}</div>
            <AIStatement :class="css.module_statement" subject="shallow" type="Models" :name="$t('BasicInformation')" :contexts="origin.descript" />
        </template>

        <!-- * 基本信息 -->
        <div :class="css.body">
            <!-- * 标题 -->
            <h2 :class="css.name" class="font-bold font-variable color-1">{{ $t("BasicInformation") }}</h2>
            <!-- * 表格 -->
            <ui-table2 :class="css.table" :option="options.info" :data="[origin.info]">
                <template #id="{ data }">
                    <template v-if="!data.id">--</template>
                    <template v-else>
                        <project-route :class="css_normalize.assets" :to="`https://www.informatics.jax.org/allele/MGI:${data.id}`">
                            {{ data.id }}
                        </project-route>
                    </template>
                </template>
                <template #mgi="{ data }">
                    <project-route :class="css_normalize.assets" :to="`https://www.informatics.jax.org/strain/MGI:${data.mgi}`">
                        {{ data.mgi }}
                    </project-route>
                </template>
                <template #mutation="{ data }">
                    <template v-if="!data.mutation">--</template>
                    <template v-else>
                        <div>{{ data.mutation }}</div>
                    </template>
                </template>
                <template #genes="{ data }">
                    <template v-if="!data.related_genes?.length">--</template>
                    <UiTooltip v-else direction="bottom" align="center" :class-extra-name="css.wrap">
                        <div :class="css_normalize.assets">{{ data.related_genes.length }}</div>
                        <template #content>
                            <div v-for="value in data.related_genes">
                                <UiIcon :name="value.tag" style="margin-right: 4px" />
                                <ProjectRoute :class="css_normalize.assets" :to="{ name: 'Gene', params: { id: value.id } }">
                                    {{ value.name }}
                                </ProjectRoute>
                            </div>
                        </template>
                    </UiTooltip>
                </template>
                <template #gene_expressions="{ data }">
                    <template v-if="!data.gene_expressions?.length">--</template>
                    <UiTooltip v-else direction="bottom" align="center" :class-extra-name="css.wrap">
                        <div :class="css_normalize.assets">{{ data.gene_expressions.length }}</div>
                        <template #content>
                            <div v-for="value in data.gene_expressions">
                                <UiIcon :name="value.tag" style="margin-right: 4px" />
                                <ProjectRoute :class="css_normalize.assets" :to="{ name: 'Gene', params: { id: value.id } }">
                                    {{ value.name }}
                                </ProjectRoute>
                            </div>
                        </template>
                    </UiTooltip>
                </template>
                <template #disease="{ data }">
                    <template v-if="!data.related_diseases?.length">--</template>
                    <UiTooltip v-else direction="bottom" align="center" :class-extra-name="css.wrap">
                        <div :class="css_normalize.assets">{{ data.related_diseases.length }}</div>
                        <template #content>
                            <div v-for="value in data.related_diseases">
                                <ProjectRoute :class="css_normalize.assets" :to="{ name: 'Disease', params: { id: value.id } }">
                                    {{ value.name }}
                                </ProjectRoute>
                            </div>
                        </template>
                    </UiTooltip>
                </template>
                <template #references="{ data }">
                    <template v-if="!data.references">--</template>
                    <template v-else>
                        <div :class="css_normalize.assets" @click="$emit('move3')">{{ data.references }}</div>
                    </template>
                </template>
            </ui-table2>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTable2, UiIcon, UiTooltip } from "various-ui";
//* 公共组件引入
import { DefaultName } from "@/components/complete";
import { AIStatement } from "@/components/controls";
//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性注册
const define = defineProps(ModulePropsOption);
//* 组合函数
const { options } = useComposable(define);
</script>
